import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { Subject } from 'rxjs';
import { AttributesMustBeFilledInConditionData } from 'src/app/components/designer/models/attributes-must-be-filled-in-condition-data';
import { FormMode } from 'src/app/controls/common/form-mode';
import { ContextualMenuEvent } from 'src/app/controls/workflows/contextual-menu-event';
import { NeedAttributes } from 'src/app/controls/workflows/need-attributes';
import { WorkflowDataInterface } from 'src/app/controls/workflows/workflow-data.interface';
import { Attribute } from 'src/app/models/attribute';

@Component({
    selector: 'app-workflow-condition-attributes-must-be-filled-in-data',
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatOptionModule, FaIconComponent, MatTooltipModule],
    templateUrl: './workflow-condition-must-be-filled-in-data.component.html',
    styleUrl: './workflow-condition-must-be-filled-in-data.component.scss'
})
export class WorkflowConditionAttributesMustBeFilledInDataComponent implements WorkflowDataInterface, OnInit, NeedAttributes {
    /**
     * Liste des icones utilisés dans le template.
     */
    public faCircleInfo = faCircleInfo;

    /**
     * Données affichées par le composant dynamique.
     */
    public _data: AttributesMustBeFilledInConditionData;

    /**
     * Spécifie les données affichées par le composant dynamique.
     */
    set data(value: string | AttributesMustBeFilledInConditionData) {
        if (typeof value === 'string') {
            this._data = JSON.parse(value);
        } else {
            this._data = value as AttributesMustBeFilledInConditionData;
        }

        this.fillForm();
    }

    /**
     * Obtient les données affichées par le composant dynamique.
     */
    get data(): AttributesMustBeFilledInConditionData {
        this.fillData();
        return this._data;
    }

    /**
     * Mode d'affichage du formulaire.
     */
    mode: FormMode;

    /**
     * Source du menu contextuel.
     */
    contextualMenuSource: Subject<ContextualMenuEvent> = new Subject<ContextualMenuEvent>();

    /**
     * Liste des attributs de la vue.
     */
    public _attributes: Attribute[];

    /**
     * Spécifie la liste des attributs de la vue.
     */
    set attributes(value: Attribute[]) {
        this._attributes = value;
        this.fillForm();
    }

    /**
     * Instance du formulaire.
     */
    public dataForm: UntypedFormGroup;

    /**
     * Constructeur.
     */
    constructor() {
        console.log('WorkflowConditionAttributesMustBeFilledInDataComponent - constructor : ');
    }
    /**
     * Appellé lors de l'initialisation du contrôle.
     */
    ngOnInit(): void {
        console.log('WorkflowConditionAttributesMustBeFilledInDataComponent - ngOnInit : ');
        this.dataForm = new UntypedFormGroup({
            attributes: new UntypedFormControl([], [Validators.required]),
        });

        this.fillForm();
    }

    /**
     * Indique si le formulaire est valide.
     */
    public isValid(): boolean {
        return this.dataForm.valid;
    }

    /**
     * Retourne une valeur indiquant si l'utilisateur a modifié des valeurs du formulaire.
     */
    public get dirty(): boolean {
        return this.dataForm && this.dataForm.dirty;
    }

    /**
     * Annulle les changements effectués par l'utilisateur.
     */
    public clearData() {
        this.dataForm.markAsPristine();
    }

    /**
     * Remplit le formulaire avec les données.
     */
    private fillForm() {
        if (this.dataForm) {
            if (this._data) {
                this.dataForm.get('attributes').setValue(this._data.attributes);
            }
        }
    }

    /**
     * Met à jour les données à partir du formulaire.
     */
    private fillData() {
        let updatedData: AttributesMustBeFilledInConditionData = new AttributesMustBeFilledInConditionData();
        updatedData.attributes = this.dataForm.get('attributes').value;

        this._data = updatedData;
    }
}
